import { createListenerMiddleware, type Dispatch } from "@reduxjs/toolkit";

import {
  flushAction,
  loadAction,
  type NautilusStateAction,
  redoAction,
  revertAction,
  sendServerActionCompleted,
  sendServerActionInProgressAction,
  undoAction,
} from "../nautilusActions.ts";
import type { NautilusDesignerState } from "../nautilusState.ts";
import { resetNextIdOffset } from "../nextIdOffset.ts";
import { type SendActionToServer } from "../serverActions.ts";

export interface RevisionDeliveryMiddlewareOptions {
  sendActionToServer: SendActionToServer;
}

export const serverActionDeliveryListenerCreate = ({ sendActionToServer }: RevisionDeliveryMiddlewareOptions) => {
  const listener = createListenerMiddleware<NautilusDesignerState, Dispatch<NautilusStateAction>>();
  listener.startListening({
    predicate: (action, { server: { unsentServerActions, sendInProgress } }) =>
      (sendServerActionCompleted.match(action) ||
        flushAction.match(action) ||
        undoAction.match(action) ||
        redoAction.match(action)) &&
      !sendInProgress &&
      unsentServerActions.length > 0,
    effect: async (_action, { getState, dispatch, signal }) => {
      const {
        server: { unsentServerActions },
      } = getState();

      const serverActionToSend = unsentServerActions[0];

      try {
        const inProgressServerAction = serverActionToSend;
        dispatch(
          sendServerActionInProgressAction({ action: inProgressServerAction, startedAt: new Date(), attempt: 1 }),
        );
        await sendActionToServer(serverActionToSend, { signal });
        dispatch(sendServerActionCompleted(inProgressServerAction));
      } catch (err) {
        dispatch(revertAction());
        throw err;
      }
    },
  });
  // probably should be separate file but so small
  listener.startListening({
    actionCreator: loadAction,
    effect: () => {
      resetNextIdOffset();
    },
  });
  return listener;
};
